<template>
    <div id="app">

        <custom-header></custom-header>

        <slider id="cal-slider"/>

        <about id="cal-about"/>

        <service id="cal-services"/>

        <appointment id="cal-appointment"/>

        <!--<practice id="cal-practice"/>-->

        <!--<team id="cal-team"/>-->

        <testimonials id="cal-testimonials"/>

        <!--<faq id="cal-faq"/>-->

        <timeline id="cal-timeline"/>

        <news id="cal-news"/>

        <contact-us id="cal-contact-us"/>

        <custom-footer></custom-footer>
    </div>
</template>

<script>
    import CustomHeader from './components/Header';
    import Slider from './components/Slider';
    import About from './components/About';
    import Service from './components/Service';
    import Appointment from './components/Appointment';
    import Timeline from './components/Timeline';
    import Testimonials from './components/Testimonials';
    import News from './components/News';
    import ContactUs from './components/ContactUs';
    import CustomFooter from './components/Footer';

    export default {
        name: 'app',
        components: {
            CustomHeader,
            Slider,
            About,
            Service,
            Appointment,
            Timeline,
            Testimonials,
            News,
            ContactUs,
            CustomFooter
        },
        mounted () {

        }
    }
</script>

<style lang="scss">
    @import "theme/variables";
    @import '../node_modules/font-awesome/scss/font-awesome';
    @import "theme/main";
</style>
